export default "__VITE_ASSET__HRJn5I4C__"